import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AllGroupMenuType } from '../redux/auth/authTypes';
import { RootState } from '../redux/rootReducers';

export const useMenuCheck: any = (initalState?:string) => {
  const allGroupMenu = useSelector((state: RootState) => state.auth.allGroupMenus);
  const [isMenuPresent, setIsMenuPresent] = useState<boolean>(initalState?.length ? false : true);

  const checkMenuFunction = useCallback((menuName: string, type: string) => {
    if (type === "menu") {
      let isMenuNamePresent = allGroupMenu?.find((menu: AllGroupMenuType) => menu.menu_name === menuName);
      setIsMenuPresent(!!isMenuNamePresent);
    }
    else {
      let isMenuNamePresent = allGroupMenu.find((menu: AllGroupMenuType) => menu.front_end_route === menuName);
      setIsMenuPresent(!!isMenuNamePresent);
    }

  }, [])

  return [isMenuPresent, checkMenuFunction];
};